import script from "./BackToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./BackToTop.vue?vue&type=script&setup=true&lang=js"

import "./BackToTop.vue?vue&type=style&index=0&id=b187396a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b187396a"]])

export default __exports__